/** GeoJSON-style pair: [lng, lat]. */
export type LngLatPair = [number, number];

export function isNullIslandLocation(
  location: readonly number[] | null | undefined,
): boolean {
  if (!location || location.length < 2) {
    return false;
  }
  const [lng, lat] = location;
  return Number.isFinite(lng) && Number.isFinite(lat) && lng === 0 && lat === 0;
}
